import React, {PropTypes} from "react";
import { Field } from "redux-form";
import { DayPicker } from "../../../../common/form";
import moment from "moment";

class HistorySelector extends React.Component {
  /**
   * The purpose of this component is to allow the user
   * to select a month. Once a month is selected (YYYY-MM),
   * the 5 months before the selected one
   * are also appended to the selected months. This is later returned to the
   * Accounting export component or the Insurer export component. It will allow us
   * to fetch exports and filter them by periods.
   */
  constructor(props, context) {
    super(props, context);
    this.handleHistoryChange = this.handleHistoryChange.bind(this);
    this.subtractMonths = this.subtractMonths.bind(this);
    this.state = {
      periodsToSend: [],
      chosenDate: null,
    };
  }

  componentDidMount() {
    let todaysDateObj = new Date();
    todaysDateObj = todaysDateObj.toISOString().split("T")[0];
    let periodFormat =
      todaysDateObj.split("-")[0] + "/" + todaysDateObj.split("-")[1];

    this.setState({ chosenDate: periodFormat });
    periodFormat = periodFormat.replace("/", "-");

    let pastMonths = this.getPastSixMonths(periodFormat);
    pastMonths.push(periodFormat);

    this.props.setPeriodsToSend(pastMonths);
  }

  subtractMonths(date, months) {
    date.setMonth(date.getMonth() - months);
    return date;
  }

  getPastSixMonths(date) {
    let dateFiltersArr = [];

    let dateObj = new Date(date + "-01T00:00");
    let subtractedDate = dateObj;

    for (let i = 0; i < 5; i++) {
      subtractedDate = this.subtractMonths(subtractedDate, 1);
      let objToPush = JSON.parse(JSON.stringify(subtractedDate));

      let periodFormatDate =
        objToPush.split("-")[0] + "-" + objToPush.split("-")[1];
      dateFiltersArr.push(periodFormatDate);
    }

    return dateFiltersArr;
  }

  handleHistoryChange(value) {
    let dateString = value._d.toISOString().split("T")[0];

    let formattedDateStringArr = dateString.split("-");
    let formattedDateString =
      formattedDateStringArr[0] + "-" + formattedDateStringArr[1];

    let pastMonthsArray = this.getPastSixMonths(formattedDateString);
    pastMonthsArray.push(formattedDateString);

    this.props.setPeriodsToSend(pastMonthsArray);
  }

  render() {
    const minimumDate = (current) =>
      current.isBefore(moment().add(2, "M").startOf("month")) &&
      current.isAfter(moment("2021-03-01", "YYYY-MM-DD"));

    return (
      <div className={this.props.class}>
        <Field
          id="period"
          name="period"
          type="text"
          component={DayPicker}
          optionalWidth={"150px"}
          props={{
            dateFormat: "YYYY/MM",
            onChangeFunc: this.handleHistoryChange,
            isValidDate: minimumDate,
          }}
          placeholder={this.state.chosenDate ? this.state.chosenDate : null}
        />
      </div>
    );
  }
}

HistorySelector.propTypes = {
  setPeriodsToSend: PropTypes.func,
  class: PropTypes.string
};

export default HistorySelector;



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/historySelector/HistorySelector.js